const enum DatasetEnum {
  MY_DATA_LIST = "/system/dataset/datasetList",
  MY_DATA_DETAIL = "/system/dataset/datasetDetail",
  PUT_DATA = "/dataset/new/save",
  DELETE_DATA = "/system/dataset/deleteDataset",
  DATA_MARKETS = "/dataset/datasetListRight",
  DATA_MARKETS_TAGS = "/dataset/datasetListLeft",
  PUBLISH_DEMAND = "/demand/collection",
  DATA_DETAIL = "/dataset/datasetDetail",
  APPLY_QUALITY_REPORT = "/dataset/applyQualityReport",
  GET_ALGORITHM_LIST = "/data/trusteeship/list",
  GET_DATA_CHAIN_STATUS = "/system/dataset/datasetIsExist",
}
export default DatasetEnum;
